import React from "react";
import ReactDOM from "react-dom";
import { hydrateBrandingFromSession } from "./branding/bootBranding";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

hydrateBrandingFromSession();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
